import { CampaignActionsGroup, SmsActionPayload } from '../../../../../models/src/lib/campaign/campaign';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, EventEmitter, Input, Output, ChangeDetectorRef, SimpleChanges } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { CommonService, NotificationService, TimeconversionService, ToastMessageService } from '@fitness-force/api';
import { AutomationEventType, CampaignSource, OwnershipLevel, Roles, SMSSendType, SendNotificationTo, StaffStatus, Status } from '@fitness-force/enum';
import { ErrorMsgComponent } from '@fitness-force/errors';
import { Actions, AutomationActionPayload, AutomationMaster, CampaignRequest, ClientById, NotificationError, REPORTSTOREINTERFACE, ReportDataForCampaign, Reports, SMSFromMaster, SMSTemplateMaster, STAFFINTERFACE, ScheduleActionPayload, SendFreeFormSmsRequest, SendSmsTemplateRequest, SmsTemplateMaster, SourceDataExtractionRules } from '@fitness-force/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CampaignService } from 'libs/api/src/lib/campaign/campaign.service';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';

import { DialogModule } from 'primeng/dialog';
import { SelectModule } from 'primeng/select';
import { EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { InputTextModule } from 'primeng/inputtext';

import { MessageModule } from 'primeng/message';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, Observable, catchError, distinctUntilChanged, forkJoin, map } from 'rxjs';
import { AutomationScheduleTypeComponent } from '../automation-schedule-type/automation-schedule-type.component';
import Statsig from 'statsig-js';
import { AvatarModule } from 'primeng/avatar';
import { CheckboxModule } from 'primeng/checkbox';
import { Store } from '@ngrx/store';
import { STAFF_STATE } from 'apps/ff-frontend/src/app/state/app.state';
import { MultiSelectModule } from 'primeng/multiselect';
import { SkeletonModule } from 'primeng/skeleton';
import { CORPORATE_CONFIG_DETAILS } from '@fitness-force/constants';
@Component({
  selector: 'send-bulk-sms',
  templateUrl: './send-bulk-sms.component.html',
  styleUrls: ['./send-bulk-sms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    ToggleSwitchModule,
    InputTextModule,
    DatePickerModule,
    SelectModule,
    EditorModule,
    ButtonModule,
    
    FileUploadModule,
    ErrorMsgComponent,
    MessageModule,
    StyleClassModule,
    AutomationScheduleTypeComponent,
    AvatarModule,
    CheckboxModule,
    MultiSelectModule,
    SkeletonModule,
    TranslateModule
]
})

export class SendBulkSmsComponent implements OnInit {
  @Input('visible') showPopup = false;
  @Input('staffId') assignedToStaffId = 0;
  @Input('tenantId') tenantId = 0;
  @Input('franchiseId') franchiseId = 0;
  @Input('totalRecords') totalRecords = new BehaviorSubject<number>(0);
  @Input('SMSSendType') smsSendType: SMSSendType = SMSSendType.FreeForm;
  @Input('columnData') columnData = new BehaviorSubject<any>([] as []);
  @Input('CampaignSource') CampaignSource : CampaignSource = CampaignSource.Clients;
  @Input('ReportDataForCampaign') ReportDataForCampaign = new BehaviorSubject<ReportDataForCampaign>({} as ReportDataForCampaign); 
  @Input('selectedAllData') selectedAllData = new BehaviorSubject<boolean>(false);
  @Input('SelectedClient') SelectedClient = new BehaviorSubject<ClientById>({} as ClientById); 
  @Input('actionPayload') actionPayload = new BehaviorSubject<SmsActionPayload>({} as SmsActionPayload); 
  @Input('automationMaster') automationMaster = new BehaviorSubject<AutomationMaster>({} as AutomationMaster);
  @Input('formGroup') formGroup: any  = new BehaviorSubject<any>(null);
  @Input('uuid') uuid: string  = "";
  @Input('notificationTo') notificationTo: SendNotificationTo = SendNotificationTo.Client;
  @Input('ownership') ownership: OwnershipLevel = OwnershipLevel.Tenant;
  @Input('mode') mode: string  = "create";
  @Input('scheduleInMin') scheduleInMin: number  = 0;
  @Output('closeSendSmsPopup') closeSendSmsPopup: EventEmitter<any> = new EventEmitter();
  @Output('hide') HidePopup: EventEmitter<{closePopup: boolean, data:any | null, form:UntypedFormGroup | null, uuid:string, notificationTo: SendNotificationTo}> = new EventEmitter();
  
  smsFrom = new BehaviorSubject<SMSFromMaster[]>([]);
  smsTemplateMasters$ = new BehaviorSubject<SmsTemplateMaster[]>({} as SmsTemplateMaster[]);
  smsTemplateMaster$ = new BehaviorSubject<SMSTemplateMaster | null>({} as SMSTemplateMaster);
  sendSmsForm: UntypedFormGroup = new UntypedFormGroup({});
  selectedReport:REPORTSTOREINTERFACE = {} as REPORTSTOREINTERFACE;
  bodyreadOnly:boolean=false;
  btnLoading:boolean=false;
  showCampaign = new BehaviorSubject<boolean>(false);
  accessedStaffs:STAFFINTERFACE[] =[];
  showScheduleType = new BehaviorSubject<boolean>(false);
  loading = true;
  CorporateConfigDetails = CORPORATE_CONFIG_DETAILS;


  constructor(private notificationService: NotificationService, 
    private fb:FormBuilder,
    private toastService:ToastMessageService,
    private timeService:TimeconversionService,
    private campaignsService: CampaignService,
    private cd: ChangeDetectorRef,
    private translateService: TranslateService,
    private store: Store,
    private commonService: CommonService) {

    this.sendSmsForm = this.fb.group({
      is_visible: [false, [Validators.required]],
      campaign_name: ['', []],
      campaign_action_date: [new Date(), []],
      campaign_description: ['', []],
      sms_from: ['',[Validators.required]],
      source_date_extraction_rules: [],
      body: ['',[Validators.required]],
      sms_template : [''],
      automation_timings_type : [''],
      automation_schedule_type : [''],
      automation_timing : [''],
      notify_record_associated_staff:[''],
      notify_additional_staff_to:[]
    });

   }

   ngOnInit(): void {
    if (Statsig.checkGate('show_campaign'))
    {
      this.showCampaign.next(true);
    }
    this.componentInit();
   
}

componentInit()
{
  this.store.select(STAFF_STATE).subscribe((staffs: any) => {
    this.accessedStaffs = staffs.staffList.filter((s: STAFFINTERFACE) => 
    (s.role !== Roles.FFAdmin && s.role.toString() !== Roles[Roles.FFAdmin]) &&
    (s.status === StaffStatus.Active || s.status.toString() === StaffStatus[StaffStatus.Active])
  );
  });

  let forkArray: Observable<any>[] = [];
  switch (this.ownership) {
    case OwnershipLevel.Company:
      forkArray = [
        this.notificationService.getSmsTemplatesByOwnership(this.ownership, 0, 0),
        this.notificationService.getSendSMSFromListByOwnership(this.ownership, 0, 0)
      ];
      break;

    case OwnershipLevel.Franchise:
      forkArray = [
        this.notificationService.getSmsTemplatesByOwnership(this.ownership, 0, this.franchiseId),
        this.notificationService.getSendSMSFromListByOwnership(this.ownership, 0, this.franchiseId)
      ];
      break;

    case OwnershipLevel.Tenant:
      forkArray = [
        this.notificationService.getSmsTemplatesByOwnership(this.ownership, this.tenantId, 0),
        this.notificationService.getSendSMSFromListByOwnership(this.ownership, this.tenantId, 0)
      ];
      break;

    default:
      break;
  }

forkJoin(forkArray).pipe(
  map(([smsTemplatesRes, sendSmsListRes]) => {
    const smsTemplates = smsTemplatesRes.items as SmsTemplateMaster[] || [];
    var sendSmsList = sendSmsListRes.items  as SMSFromMaster[] || [];
    sendSmsList = sendSmsList.filter(o =>(o.status === Status.Active || o.status.toString() === Status[Status.Active]) || (o.status));

    let filteredSmsTemplates = smsTemplates.filter(o => o.status === Status.Active || o.status.toString() === Status[Status.Active]);
    
    if (this.smsSendType === SMSSendType.Automation) {
      filteredSmsTemplates = filteredSmsTemplates.filter(o => o.event_type === this.automationMaster.value.automation_type || o.event_type.toString() === AutomationEventType[this.automationMaster.value.automation_type]);
    } else if (this.smsSendType === SMSSendType.Campaign) {
      filteredSmsTemplates = filteredSmsTemplates.filter(o => o.event_type === AutomationEventType.Campaign || o.event_type.toString() === AutomationEventType[AutomationEventType.Campaign]);
    }
    
    this.smsTemplateMasters$.next(filteredSmsTemplates);
    sendSmsList.forEach(sms => {
      if(this.CorporateConfigDetails['SMS'].includes(sms.from_number))
      {
        sms.isCorporate = true;
      }
      else{
        sms.isCorporate = false;
      }
    });
    this.smsFrom.next(sendSmsList);
    this.SelectedSmsFromFormControl.setValue(sendSmsList.filter(o => o.isCorporate === false)[0]);
    
    if (this.actionPayload && this.actionPayload.value) {
      this.setInitData();
    }
    else{
      this.showScheduleType.next(true);
    }
    this.loading = false;
    this.cd.detectChanges();
  }),
  catchError(error => {
    this.smsTemplateMasters$.next([]);
    this.smsFrom.next([]);
    this.loading = false;
    this.cd.detectChanges();
    return [];
  })
 ).subscribe();
  this.valueChangeFunction();
}

ngOnChanges(changes: SimpleChanges): void {
  if (changes['formGroup'] && changes['formGroup'].currentValue != null && changes['formGroup'].currentValue.value != null && changes['formGroup'].currentValue != changes['formGroup'].previousValue)
  {
    this.sendSmsForm = changes['formGroup'].currentValue.value as UntypedFormGroup;
    this.sendSmsForm.updateValueAndValidity();
  }
}

setInitData()
{
  if(this.actionPayload.value && this.actionPayload.value.sms_sender_config_id > 0)
     this.SelectedSmsFromFormControl.setValue(this.smsFrom.value.find(o => o.id == this.actionPayload.value.sms_sender_config_id))
  if(this.actionPayload.value && this.actionPayload.value.sms_template_master_id && this.actionPayload.value.sms_template_master_id > 0)
    {
      this.SelectedSmsTemplateFormControl.setValue(this.smsTemplateMasters$.value.find(o => o.id == this.actionPayload.value.sms_template_master_id));
      this.SelectSmsTemplate();
    }
  else {
      this.BodyFormControl.setValue(this.actionPayload.value.message);
   }

   if(this.mode && this.mode =='update')
    {
     let scheduleType = this.scheduleInMin > 0 ? 'After' : this.scheduleInMin < 0 ?  'Before' : 'Immediate';
     let SelectedAutomationTimingType =  this.commonService.formatScheduleTime(this.scheduleInMin,this.automationMaster.value.automation_type.toString());
     this.SelectedAutomationScheduleTypeFormControl.setValue({key:SelectedAutomationTimingType.key,value:SelectedAutomationTimingType.key});
     this.SelectedAutomationTimingTypeFormControl.setValue(scheduleType);
     this.sendSmsForm.controls['automation_timing'].setValue({key:SelectedAutomationTimingType.name,value:SelectedAutomationTimingType.value});
     this.sendSmsForm.updateValueAndValidity();
     this.cd.detectChanges();
    };
    this.showScheduleType.next(true);
}

valueChangeFunction() {
  this.IsVisibleFormControl.valueChanges
    .pipe(distinctUntilChanged())
    .subscribe((value: any) => {
      if (value) {
        this.CampaignNameFormControl.setValidators([Validators.required]);
        this.CampaignDescriptionFormControl.setValidators([Validators.required]);
        this.CampaignActionDateFormControl.setValidators([Validators.required]);
      } else {
        this.CampaignNameFormControl.removeValidators([Validators.required]);
        this.CampaignDescriptionFormControl.removeValidators([Validators.required]);
        this.CampaignActionDateFormControl.removeValidators([Validators.required]);
      }
    });

    this.SelectedSmsTemplateFormControl.valueChanges
    .pipe(distinctUntilChanged())
    .subscribe((value: any) => {
      if (value) {
        //this.SubjectFormControl.disable();
        this.BodyFormControl.disable();
        this.bodyreadOnly=true;
      } else {
        //this.SubjectFormControl.enable();
        this.BodyFormControl.enable();
        this.bodyreadOnly=false;
      }
      this.cd.detectChanges();
    });
}

SelectSmsTemplate()
{
  let service:any;
  switch (this.ownership) {
    case OwnershipLevel.Company:
     service = this.notificationService.getSMSTemplateByIdWithOwnership(this.ownership,this.SelectedSmsTemplateFormControl.value.id,0,0);
      break;
    case OwnershipLevel.Franchise:
      service = this.notificationService.getSMSTemplateByIdWithOwnership(this.ownership,this.SelectedSmsTemplateFormControl.value.id,this.franchiseId,0);
      break;
    case OwnershipLevel.Tenant:
      service = this.notificationService.getSMSTemplateByIdWithOwnership(this.ownership,this.SelectedSmsTemplateFormControl.value.id,0,this.tenantId);
      break;
    default:
      break;
  }

  service.subscribe({
    next: (res:SMSTemplateMaster) => {
      this.smsTemplateMaster$.next(res);
      this.BodyFormControl.setValue(res.body_primary_language || res.body_secondary_language);
    },
    error: (error:any) => {
      this.smsTemplateMaster$.next(null);
      this.BodyFormControl.setValue(null);
    },
  });
}

getClientMobileNos()
{
  if(this.smsSendType ==  SMSSendType.Bulk)
  {
    let data = this.columnData.getValue();
    data = data.filter((o: { clt_mobile_country_code: string; clt_mobile_no: string; })  => o.clt_mobile_country_code !== "0" && o.clt_mobile_no !== "0");
    let uniqueData = data.map((o: any) =>  o.clt_mobile_country_code+" "+o.clt_mobile_no );
    return uniqueData.filter((value: any, index: any, self: string | any[]) => self.indexOf(value) === index);
  }
  else if(this.smsSendType ==  SMSSendType.FreeForm)
  {
    return [this.SelectedClient.value.mobile_country_code+this.SelectedClient.value.mobile_number];
  }
  else{
    return null;
  }
}

getClientIds():any
{
  if(this.smsSendType ==  SMSSendType.Bulk)
     return this.filterUniqueNumbers(this.columnData.getValue().map((o: any) => parseInt(o.clt_id)));
  else if(this.smsSendType ==  SMSSendType.FreeForm)
    {
      return [this.SelectedClient.value.id];
    }
  else null;
}


SaveData()
  {
    if(this.sendSmsForm.valid)
    {
      this.btnLoading=true;
      const formValues = this.sendSmsForm.value;
      let smsActionPayload:SmsActionPayload = {} as SmsActionPayload;
      if(this.SelectedSmsTemplateFormControl.value)
      {
        smsActionPayload.sms_template_master_id = this.SelectedSmsTemplateFormControl.value.id;
        smsActionPayload.sms_sender_config_id=this.SelectedSmsFromFormControl.value.id;
        smsActionPayload.message= this.BodyFormControl.value;
      }
      else{
        smsActionPayload.sms_template_master_id=null;
        smsActionPayload.sms_sender_config_id=this.SelectedSmsFromFormControl.value.id;
        smsActionPayload.message= this.BodyFormControl.value;
      }
      console.log(smsActionPayload);
      if(this.smsSendType == SMSSendType.Automation)
      {
        let actions : Actions= {} as Actions;
        let data :ScheduleActionPayload = {
          schedule_in_min: 0,
          actions: actions,
          action_name: "",
          associated_staff: false,
          staff_ids:[],
          description:""
        };
        data.schedule_in_min=  this.SelectedAutomationTimingFormControl.value ?  this.SelectedAutomationTimingFormControl.value.value : 0;
        data.action_name = this.SelectedAutomationTimingFormControl.value ?  this.SelectedAutomationTimingFormControl.value.key :  this.SelectedAutomationTimingTypeFormControl.value;
        data.associated_staff = this.SelectedAssociatedStaffFormControl && this.SelectedAssociatedStaffFormControl.value ? this.SelectedAssociatedStaffFormControl.value  : false ;
        data.staff_ids = this.SelectedAdditionalStaffFormControl && this.SelectedAdditionalStaffFormControl.value ? this.SelectedAdditionalStaffFormControl.value.map((staff: any) => staff.id) : [];
        data.actions.email_action_payload = null;
        data.actions.sms_action_payload = smsActionPayload;
        data.actions.whatsapp_action_payload = null;
        data.actions.task_action_payload = null;
        data.description = smsActionPayload.message;
        console.log("automation data",data);
        this.showPopup=false;
        this.closeSendSmsPopup.emit(true);
        this.HidePopup.emit({closePopup:true, data:data,form:this.sendSmsForm, uuid:this.uuid,notificationTo: this.notificationTo});
      }
      else{
        this.showPopup=false;
        this.closeSendSmsPopup.emit(true);
        this.HidePopup.emit({closePopup:true, data:smsActionPayload,form:this.sendSmsForm, uuid:this.uuid,notificationTo: this.notificationTo});
      }

     
    }
    else {
      Object.keys(this.sendSmsForm.controls).forEach((field) => {
        const control = this.sendSmsForm.get(field);
        control?.markAsTouched({ onlySelf: true });
      });
      const firstElementWithError: Element | null = document.querySelector('.ng-invalid');
      if (firstElementWithError) firstElementWithError.scrollIntoView({ behavior: 'smooth' });
      this.btnLoading=false;
      this.cd.detectChanges();
    }
  }

SendSms()
{
  if(this.sendSmsForm.valid)
  {
    this.btnLoading=true;
    const formValues = this.sendSmsForm.value;
    if(this.smsSendType == SMSSendType.Bulk)
    {
      let payloadRequest : CampaignRequest[] = [] as CampaignRequest[];
      let payload : CampaignRequest = {} as CampaignRequest; 
      payload.campaign_name=formValues["campaign_name"];
      payload.campaign_isvisble=formValues["is_visible"];
      payload.campaign_description=formValues["campaign_description"];
      payload.tenant_id=this.tenantId;
      payload.campaign_ownership = OwnershipLevel.Tenant;
      payload.campaign_franchise = 0;
      payload.actions_group  = {} as CampaignActionsGroup;
      let actionGroups: CampaignActionsGroup = {} as CampaignActionsGroup;
      actionGroups.campaign_action_date = payload.campaign_isvisble ? this.timeService.ConvertLocalDateTimeToUTC(formValues["campaign_action_date"]) :  new Date().toISOString();
      actionGroups.source_data_type= this.CampaignSource;
      let sourceDataExtractionRules : SourceDataExtractionRules = {} as SourceDataExtractionRules;
      if(this.CampaignSource == CampaignSource.Clients) {
        sourceDataExtractionRules.clients= this.getClientIds();
        sourceDataExtractionRules.reports=null;
        sourceDataExtractionRules.rule= null;
        sourceDataExtractionRules.jsonrule= null;

      }
      else if(this.CampaignSource == CampaignSource.Report) {
        let reports : Reports ={} as Reports;
        let selectedReportData = this.ReportDataForCampaign.value;
        reports.payload = selectedReportData.rpt_fltr_payload;
        reports.relative_date = selectedReportData.rpt_fltr_relative_date_range;
        reports.report_key = selectedReportData.report_key;
        sourceDataExtractionRules.reports = reports;
        sourceDataExtractionRules.clients= null
        sourceDataExtractionRules.rule= null;
        sourceDataExtractionRules.jsonrule= null;
      }
      else{
        sourceDataExtractionRules.clients=null;
        sourceDataExtractionRules.reports=null;
        sourceDataExtractionRules.rule= null;
        sourceDataExtractionRules.jsonrule= null;
      }
      actionGroups.source_data_extraction_rules = sourceDataExtractionRules;
      actionGroups.action_payload = [] as AutomationActionPayload[];
      let actionPayloads: AutomationActionPayload = {
        actions: {
          client_email_action_payload: null,
          client_sms_action_payload: null,
          client_whatsapp_action_payload: null,
          staff_email_action_payload: null,
          staff_sms_action_payload: null,
          staff_whatsapp_action_payload: null,
          staff_task_action_payload: null,
          client_pushnotification_action_payload: null,
          staff_pushnotification_action_payload: null,
          notification_staff: null
        },
        schedule_in_min: 0
      };
      actionPayloads.actions.staff_email_action_payload= null;
      actionPayloads.actions.client_email_action_payload= null;
      actionPayloads.actions.staff_task_action_payload= null;
      actionPayloads.actions.staff_whatsapp_action_payload= null;
      actionPayloads.actions.client_whatsapp_action_payload= null;
      let smsActionPayload:SmsActionPayload = {} as SmsActionPayload;
      if(this.SelectedSmsTemplateFormControl.value)
      {
        smsActionPayload.sms_template_master_id = this.SelectedSmsTemplateFormControl.value.id;
        smsActionPayload.sms_sender_config_id=this.SelectedSmsFromFormControl.value.id;
        smsActionPayload.message= this.BodyFormControl.value;
      }
      else{
        smsActionPayload.sms_template_master_id=null;
        smsActionPayload.sms_sender_config_id=this.SelectedSmsFromFormControl.value.id;
        smsActionPayload.message= this.BodyFormControl.value;
      }
      actionPayloads.actions.client_sms_action_payload= smsActionPayload;
      actionPayloads.actions.staff_sms_action_payload= null;
      actionGroups.action_payload.push(actionPayloads);
      payload.actions_group= actionGroups;
      payloadRequest.push(payload);
      this.campaignsService.CreateCampaigns(payloadRequest).subscribe({
        next: (res) => {
          this.translateService.get('SEND_SMS.MSG.SMS_SEND')
            .subscribe((translation) => {
             this.toastService.showSuccess(translation);
            });
            this.btnLoading=false;
            this.cd.detectChanges();
            this.closePopupUp();
        },
        error: (error) => {
          if(error.originalError.status == 201)
            {
              this.translateService.get('SEND_SMS.MSG.SMS_SEND')
              .subscribe((translation) => {
              this.toastService.showSuccess(translation);
              });
              this.closePopupUp();
            }
            else{
              this.toastService.showError(error);
            }
          this.btnLoading=false;
          this.cd.detectChanges();
        },
      });
    }
    else{
      let freeFormPayload:SendFreeFormSmsRequest = {} as SendFreeFormSmsRequest;
      let templatePayload:SendSmsTemplateRequest = {} as SendSmsTemplateRequest;
      let service:any;
      if(this.SelectedSmsTemplateFormControl.value){
        templatePayload.message= this.BodyFormControl.value;
        templatePayload.sms_sender_config_id = this.SelectedSmsFromFormControl.value.id;
        templatePayload.sms_template_master_id = this.SelectedSmsTemplateFormControl.value.id;
        service = this.notificationService.SendTemplatedSms(this.tenantId,this.getClientIds(),templatePayload);
      }
      else{
        freeFormPayload.from = this.SelectedSmsFromFormControl.value.from_number;
        freeFormPayload.message= this.BodyFormControl.value;
        freeFormPayload.sms_sender_config_id = this.SelectedSmsFromFormControl.value.id;
        freeFormPayload.to = this.getClientMobileNos();
        service = this.notificationService.SendFreeFormSms(this.tenantId,this.SelectedClient.value.id, freeFormPayload);
      }
      service.subscribe({
        next: (res:any) => {
          this.translateService.get('SEND_SMS.MSG.SMS_SEND')
            .subscribe((translation) => {
            this.toastService.showSuccess(translation);
            });
            this.btnLoading=false;
            this.cd.detectChanges();
            this.closePopupUp();
        },
        error: (error:any) => {
          if(error.originalError.status == 201)
          {
            this.translateService.get('SEND_SMS.MSG.SMS_SEND')
            .subscribe((translation) => {
            this.toastService.showSuccess(translation);
            });
            this.closePopupUp();
          }
          else if(error.originalError.error &&  Array.isArray(error.originalError.error) && error.originalError.error.length>0)
            {
              error.originalError.error.forEach((element: NotificationError) => {
                if(element.success)
                  {
                    this.translateService.get('SEND_SMS.MSG.SMS_SEND')
                    .subscribe((translation) => {
                      this.toastService.showSuccess(translation);
                    });
                  }
                  else
                  this.toastService.showErrorMessage(element.error.errorMessage);
              });
            }
          else{
            this.toastService.showError(error);
          }
          this.btnLoading=false;
          this.cd.detectChanges();
        },
      });
    }
  }
  else {
    Object.keys(this.sendSmsForm.controls).forEach((field) => {
      const control = this.sendSmsForm.get(field);
      control?.markAsTouched({ onlySelf: true });
    });
    const firstElementWithError: Element | null = document.querySelector('.ng-invalid');
    if (firstElementWithError) firstElementWithError.scrollIntoView({ behavior: 'smooth' });
    this.btnLoading=false;
    this.cd.detectChanges();
  }
}

getTomorrowDate(): string {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const tomorrowDate = tomorrow.toISOString();
  return tomorrowDate;
}

filterUniqueNumbers(array: number[]): number[] {
  const counts: { [key: number]: number } = {}; 
  const uniqueNumbers: number[] = [];
  array.forEach((number) => {
    counts[number] = (counts[number] || 0) + 1;
  });
  array.forEach((number) => {
    if (counts[number] === 1) {
      uniqueNumbers.push(number);
    }
  });
  return uniqueNumbers;
}

closePopupUp()
{
  this.showPopup=false;
  this.closeSendSmsPopup.emit(true);
  this.HidePopup.emit({closePopup:true, data:null, form:null, uuid:this.uuid,notificationTo: this.notificationTo});
}

Updatevalue(event:any)
{
  this.cd.detectChanges();
}

ngAfterViewInit() {
  this.removeQlImage();
}

removeQlImage() {
  const imgButton = document.getElementsByClassName('ql-image');
  for (let i = 0; i < imgButton.length; i++) {
    imgButton[i].remove();
  }

  const cleanButton = document.getElementsByClassName('ql-clean');
  for (let i = 0; i < cleanButton.length; i++) {
    cleanButton[i].remove();
  }

  const codeBlock = document.getElementsByClassName('ql-code-block');
  for (let i = 0; i < codeBlock.length; i++) {
    codeBlock[i].remove();
  }
  const linkButton = document.getElementsByClassName('ql-link');
  for (let i = 0; i < linkButton.length; i++) {
    linkButton[i].remove();
  }
}

public get isFormValid()
{
  return this.sendSmsForm.valid;
}

get IsVisibleFormControl(): UntypedFormControl {
  return this.sendSmsForm.controls['is_visible'] as UntypedFormControl;
}

get CampaignNameFormControl(): UntypedFormControl {
  return this.sendSmsForm.controls['campaign_name'] as UntypedFormControl;
}

get CampaignDescriptionFormControl(): UntypedFormControl {
  return this.sendSmsForm.controls['campaign_description'] as UntypedFormControl;
}

get CampaignActionDateFormControl(): UntypedFormControl {
  return this.sendSmsForm.controls['campaign_action_date'] as UntypedFormControl;
}

get SubjectFormControl(): UntypedFormControl {
  return this.sendSmsForm.controls['subject'] as UntypedFormControl;
}

get BodyFormControl(): UntypedFormControl {
  return this.sendSmsForm.controls['body'] as UntypedFormControl;
}

get SelectedSmsTemplateFormControl(): UntypedFormControl {
  return this.sendSmsForm.controls['sms_template'] as UntypedFormControl;
}

get SelectedSmsFromFormControl()
{
  return this.sendSmsForm.controls['sms_from'] as UntypedFormControl;
}

get SelectedAutomationTimingTypeFormControl()
{
  return this.sendSmsForm.controls['automation_timings_type'] as UntypedFormControl;
}

get SelectedAutomationTimingFormControl()
{
  return this.sendSmsForm.controls['automation_timing'] as UntypedFormControl;
}

get SelectedAutomationScheduleTypeFormControl()
{
  return this.sendSmsForm.controls['automation_schedule_type'] as UntypedFormControl;
}

get SelectedAdditionalStaffFormControl()
{
  return this.sendSmsForm.controls['notify_additional_staff_to'] as UntypedFormControl;
}

get SelectedAssociatedStaffFormControl()
{
  return this.sendSmsForm.controls['notify_record_associated_staff'] as UntypedFormControl;
}

public get GetSMSSendType()
{
  return SMSSendType;
}

public get SendNotificationTo()
{
  return SendNotificationTo;
}

}

